// Источник истины по типизации кодов - словари

/** Коды вида организации (DictTypes.OrganizationTypes)
 *
 * @enum {number} IP - ИП (code: 1)
 * @enum {number} TOO - ТОО (code: 2)
 * @enum {number} AO - АО (code: 3)
 * @enum {number} Government - Государственное предприятие (code: 4)
 * @enum {number} Other - Иное (code: 5)
 */
export enum EOrganizationTypesCode {
  /** ИП */
  IP = 1,
  /** ТОО */
  TOO = 2,
  /** АО */
  AO = 3,
  /** Государственное предприятие */
  Government = 4,
  /** Иное */
  Other = 5
}

/** Коды типа дилера (DictTypes.Dealers_Types)
 *
 * @enum {string} DC - ДЦ (code: 'dc')
 * @enum {string} SAP - САП (code: 'sap')
 * @enum {string} TRC - ТРЦ (code: 'trc')
 * @enum {string} NEW - NEW (code: 'new')
 */
export enum EDealersTypesCode {
  /** ДЦ */
  DC = 'dc',
  /** САП */
  SAP = 'sap',
  /** ТРЦ */
  TRC = 'trc',
  /** NEW */
  NEW = 'new'
}
